/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DirectoryCardPlayerSource } from './DirectoryCardPlayerSource';
import {
    DirectoryCardPlayerSourceFromJSON,
    DirectoryCardPlayerSourceFromJSONTyped,
    DirectoryCardPlayerSourceToJSON,
    DirectoryCardPlayerSourceToJSONTyped,
} from './DirectoryCardPlayerSource';
import type { DirectoryCardPlatform } from './DirectoryCardPlatform';
import {
    DirectoryCardPlatformFromJSON,
    DirectoryCardPlatformFromJSONTyped,
    DirectoryCardPlatformToJSON,
    DirectoryCardPlatformToJSONTyped,
} from './DirectoryCardPlatform';

/**
 * 
 * @export
 * @interface DropRosterMember
 */
export interface DropRosterMember {
    /**
     * The creator's own Drop, when one is linked.
     * @type {string}
     * @memberof DropRosterMember
     */
    dropId?: string;
    /**
     * Slug of that Drop, so the roster card links through.
     * @type {string}
     * @memberof DropRosterMember
     */
    dropSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof DropRosterMember
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof DropRosterMember
     */
    platform?: string;
    /**
     * This member's values for the fields the roster declares.
     * @type {{ [key: string]: any; }}
     * @memberof DropRosterMember
     */
    fieldValues?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof DropRosterMember
     */
    isLive: boolean;
    /**
     * Live, but on another game. True under BADGE and OFF filter modes — only STRICT hides such a member instead of badging them. When true, viewerCount, streamTitle, playerSource and platforms are withheld: they describe the other title and must not surface here.
     * @type {boolean}
     * @memberof DropRosterMember
     */
    offGame: boolean;
    /**
     * 
     * @type {number}
     * @memberof DropRosterMember
     */
    viewerCount: number;
    /**
     * Audience size, present whether or not the member is live — the max across the Drop's streaming socials. The rail's secondary sort needs a figure that survives being offline; viewerCount is zero for every offline member.
     * @type {number}
     * @memberof DropRosterMember
     */
    followerCount?: number;
    /**
     * 
     * @type {string}
     * @memberof DropRosterMember
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DropRosterMember
     */
    streamTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof DropRosterMember
     */
    gameName?: string;
    /**
     * 
     * @type {string}
     * @memberof DropRosterMember
     */
    profileImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DropRosterMember
     */
    twitchChannelId?: string;
    /**
     * 
     * @type {string}
     * @memberof DropRosterMember
     */
    kickChannelSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof DropRosterMember
     */
    youtubeChannelId?: string;
    /**
     * Which signal proved the member on-game (telemetry, category, campaign, parent, alias).
     * @type {string}
     * @memberof DropRosterMember
     */
    matchedVia?: string;
    /**
     * Prefer this over isLive. UNKNOWN means no fresh observation — render "last seen", not OFFLINE.
     * @type {string}
     * @memberof DropRosterMember
     */
    effectiveLiveState?: DropRosterMemberEffectiveLiveStateEnum;
    /**
     * Epoch ms of the last confirmed live observation.
     * @type {number}
     * @memberof DropRosterMember
     */
    lastLiveAt?: number;
    /**
     * Per-platform live state and viewer count, so a simulcaster shows a badge per platform.
     * @type {Array<DirectoryCardPlatform>}
     * @memberof DropRosterMember
     */
    platforms?: Array<DirectoryCardPlatform>;
    /**
     * 
     * @type {DirectoryCardPlayerSource}
     * @memberof DropRosterMember
     */
    playerSource?: DirectoryCardPlayerSource;
}


/**
 * @export
 */
export const DropRosterMemberEffectiveLiveStateEnum = {
    Live: 'LIVE',
    Offline: 'OFFLINE',
    Unknown: 'UNKNOWN'
} as const;
export type DropRosterMemberEffectiveLiveStateEnum = typeof DropRosterMemberEffectiveLiveStateEnum[keyof typeof DropRosterMemberEffectiveLiveStateEnum];


/**
 * Check if a given object implements the DropRosterMember interface.
 */
export function instanceOfDropRosterMember(value: object): value is DropRosterMember {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('isLive' in value) || value['isLive'] === undefined) return false;
    if (!('offGame' in value) || value['offGame'] === undefined) return false;
    if (!('viewerCount' in value) || value['viewerCount'] === undefined) return false;
    return true;
}

export function DropRosterMemberFromJSON(json: any): DropRosterMember {
    return DropRosterMemberFromJSONTyped(json, false);
}

export function DropRosterMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropRosterMember {
    if (json == null) {
        return json;
    }
    return {
        
        'dropId': json['dropId'] == null ? undefined : json['dropId'],
        'dropSlug': json['dropSlug'] == null ? undefined : json['dropSlug'],
        'label': json['label'],
        'platform': json['platform'] == null ? undefined : json['platform'],
        'fieldValues': json['fieldValues'] == null ? undefined : json['fieldValues'],
        'isLive': json['isLive'],
        'offGame': json['offGame'],
        'viewerCount': json['viewerCount'],
        'followerCount': json['followerCount'] == null ? undefined : json['followerCount'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'streamTitle': json['streamTitle'] == null ? undefined : json['streamTitle'],
        'gameName': json['gameName'] == null ? undefined : json['gameName'],
        'profileImageUrl': json['profileImageUrl'] == null ? undefined : json['profileImageUrl'],
        'twitchChannelId': json['twitchChannelId'] == null ? undefined : json['twitchChannelId'],
        'kickChannelSlug': json['kickChannelSlug'] == null ? undefined : json['kickChannelSlug'],
        'youtubeChannelId': json['youtubeChannelId'] == null ? undefined : json['youtubeChannelId'],
        'matchedVia': json['matchedVia'] == null ? undefined : json['matchedVia'],
        'effectiveLiveState': json['effectiveLiveState'] == null ? undefined : json['effectiveLiveState'],
        'lastLiveAt': json['lastLiveAt'] == null ? undefined : json['lastLiveAt'],
        'platforms': json['platforms'] == null ? undefined : ((json['platforms'] as Array<any>).map(DirectoryCardPlatformFromJSON)),
        'playerSource': json['playerSource'] == null ? undefined : DirectoryCardPlayerSourceFromJSON(json['playerSource']),
    };
}

export function DropRosterMemberToJSON(json: any): DropRosterMember {
    return DropRosterMemberToJSONTyped(json, false);
}

export function DropRosterMemberToJSONTyped(value?: DropRosterMember | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dropId': value['dropId'],
        'dropSlug': value['dropSlug'],
        'label': value['label'],
        'platform': value['platform'],
        'fieldValues': value['fieldValues'],
        'isLive': value['isLive'],
        'offGame': value['offGame'],
        'viewerCount': value['viewerCount'],
        'followerCount': value['followerCount'],
        'thumbnailUrl': value['thumbnailUrl'],
        'streamTitle': value['streamTitle'],
        'gameName': value['gameName'],
        'profileImageUrl': value['profileImageUrl'],
        'twitchChannelId': value['twitchChannelId'],
        'kickChannelSlug': value['kickChannelSlug'],
        'youtubeChannelId': value['youtubeChannelId'],
        'matchedVia': value['matchedVia'],
        'effectiveLiveState': value['effectiveLiveState'],
        'lastLiveAt': value['lastLiveAt'],
        'platforms': value['platforms'] == null ? undefined : ((value['platforms'] as Array<any>).map(DirectoryCardPlatformToJSON)),
        'playerSource': DirectoryCardPlayerSourceToJSON(value['playerSource']),
    };
}

